export default "__VITE_ASSET__CSI$XgTZ__"